export default __webpack_public_path__ + "static/media/chrome.d1b21dd1.svg";